<form [formGroup]="extensionFormGroup">
  <div>
    <span>
      <h5>{{ headings.activationExtension }}</h5>
    </span>
  </div>
  <div class="form-group input-group">
    <div class="col-md-12">
      <kendo-floatinglabel class="k-input-full" text="{{ labels.name }}">
        <input kendoTextBox formControlName="name" class="k-input-full" [value]="extension.name" />
      </kendo-floatinglabel>
    </div>
  </div>
  <div class="form-group input-group">
    <div class="col-md-12">
      <kendo-floatinglabel class="k-input-full" text="{{ labels.telephoneNumber }}">
        <input
          kendoTextBox
          formControlName="telephoneNumber"
          class="k-input-full"
          [value]="extension.telephoneNumber" />
      </kendo-floatinglabel>
    </div>
  </div>
  <div class="form-group input-group">
    <div class="col-md-12">
      <kendo-floatinglabel class="k-input-full" text="{{ labels.portfolio }}">
        <input kendoTextBox formControlName="portfolio" class="k-input-full" [value]="extension.portfolio" />
      </kendo-floatinglabel>
    </div>
  </div>
  <div>
    <span>
      <h5>{{ headings.details }}</h5>
    </span>
  </div>
  <div class="form-group input-group">
    <div class="col-md-12">
      <kendo-floatinglabel class="k-input-full" text="{{ labels.instrument }}">
        <input kendoTextBox formControlName="instrument" class="k-input-full" [value]="extension.instrument" />
      </kendo-floatinglabel>
    </div>
  </div>
  <div class="form-group input-group">
    <div class="col-md-12">
      <kendo-floatinglabel class="k-input-full" text="{{ labels.quantity }}">
        <input
          kendoTextBox
          formControlName="requestedQuantity"
          class="k-input-full"
          [value]="extension.requestedQuantity.toString()" />
      </kendo-floatinglabel>
    </div>
  </div>

  <div class="form-group input-group">
    <div class="col-md-12">
      <kendo-floatinglabel class="k-input-full" text="{{ labels.requestedActivationTime }}">
        <kendo-datetimepicker
          formControlName="requestedActivationTime"
          [format]="dateTimeFormat"
          class="k-input-full"
          [value]="extension.requestedActivationTime"></kendo-datetimepicker>
      </kendo-floatinglabel>
    </div>
  </div>
  <!-- <ng-container *ngIf="mustAcknowledgeMessageRead">
    <div class="form-group input-group text-right">
      <div class="col-md-12">
        <nexweb-acknowledge-message-read
          formControlName="acknowledgeMessageRead"
        ></nexweb-acknowledge-message-read>
      </div>
    </div>
  </ng-container> -->
</form>
